import { render, staticRenderFns } from "./linkDialog.vue?vue&type=template&id=48b0c347&scoped=true"
import script from "./linkDialog.vue?vue&type=script&lang=js"
export * from "./linkDialog.vue?vue&type=script&lang=js"
import style0 from "./linkDialog.vue?vue&type=style&index=0&id=48b0c347&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0c347",
  null
  
)

export default component.exports